export var BadgeTextDirection;
(function (BadgeTextDirection) {
    BadgeTextDirection["LEFT"] = "left";
    BadgeTextDirection["RIGHT"] = "right";
})(BadgeTextDirection || (BadgeTextDirection = {}));
/**
 * Badge Color
 */
export var BadgeColor;
(function (BadgeColor) {
    /** @deprecated in v4 => BadgeColor.MAIN */
    BadgeColor["TERTIARY"] = "TERTIARY";
    /** @deprecated in v4 => BadgeColor.MAIN */
    BadgeColor["SECONDARY"] = "SECONDARY";
})(BadgeColor || (BadgeColor = {}));
//# sourceMappingURL=BadgeEnum.js.map